module.exports = __webpack_public_path__ + "media/SessionStartSoundChords.56997638.mp3";